import { Home } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import HomePage from "./pages/HomePage";

const HomeRouter: NavigationLinkProps[] = [
  {
    id: "932f56af-045a-4d79-b765-5a002b72ea02",
    title: "Home",
    description: "",
    path: "/home",
    auth: true,
    sidebar: true,
    icon: Home,
    component: HomePage,
    requiredFeature: "ANY",
    requiredPermissions: ["ANY"],
    mobileAvailable: true,
  },
  {
    id: "932f56af-b765-b765-b765-5a002b72ea02",
    title: "Home",
    description: "",
    path: "/",
    auth: true,
    sidebar: false,
    icon: Home,
    component: HomePage,
    requiredFeature: "ANY",
    requiredPermissions: ["ANY"],
    mobileAvailable: true,
  },
];

export default HomeRouter;
